import { utils } from '@hh/global.js'

const { isMobile } = utils

class HHPDPMediaAnimation extends HTMLElement {
  constructor() {
    super()

    this.type = this.dataset.type
    this.productContainer = this.querySelector('.js-product')
    this.mediaSlide = this.querySelector(
      '.js-product-media-sticky .product-media'
    )

    if (this.type == 'model' && !isMobile()) {
      this.init()
    } else {
      this.productContainer?.classList.add('product--active')
    }

    window.addEventListener('resize', this.handleResize.bind(this))
  }

  init() {
    setTimeout(() => {
      this.productContainer?.classList.add('product--active')
    }, 1000)
  }

  handleResize() {
    if (!isMobile()) {
      this.productContainer?.classList.add('product--active')
    }
  }
}

customElements.define('hh-product-media-animation', HHPDPMediaAnimation)
